

import React, { useState } from 'react';
import axios from 'axios';
import Business_logo from '../Images/Business_logo.png';
import { FiUser, FiMail, FiPhone, FiUsers, FiTrash2 } from "react-icons/fi"; 

const UserDelete = () => {
  const [registerNo, setRegistershipNo] = useState('');
  const [userData, setUserData] = useState(null);
  const [otp, setOtp] = useState('');
  const [showOtpField, setShowOtpField] = useState(false);
  const [generatedOtp, setGeneratedOtp] = useState(null);

  const fetchUserData = async () => {
    try {
      const response = await axios.get(`https://taaiappapi.emedha.in/pages/api/api/user?registerNo=${registerNo}`);
      setUserData(response.data);
    } catch (error) {
      console.error('Error fetching user data', error);
      alert('User not found!');
    }
  };

  const sendOtp = async () => {
    try {
      const response = await axios.post('https://taaiappapi.emedha.in/pages/api/api/send-otp', { email: userData.emailId });
      setGeneratedOtp(response.data.otp);
      setShowOtpField(true);
      alert('OTP sent to email!');
    } catch (error) {
      console.error('Error sending OTP', error);
    }
  };

  const verifyAndDeleteUser = async () => {
    if (otp !== generatedOtp) {
      alert('Invalid OTP');
      return;
    }
    try {
      await axios.post('https://taaiappapi.emedha.in/pages/api/api/delete-user', { registerNo });
      alert('User deleted successfully');
      setUserData(null);
      setShowOtpField(false);
      setOtp('');
    } catch (error) {
      console.error('Error deleting user', error);
    }
  };

  return (
    <div style={styles.container}>
      {/* Header */}
      <header style={styles.header}>
        <img src={Business_logo} alt="Logo" style={styles.logo} />
        <h1 style={styles.title}>Welcome to TAAI Convention</h1>
      </header>

      {/* Main Content */}
      <div style={styles.content}>
        {/* Search Field */}
        <div style={styles.searchContainer}>
          <input
            type="text"
            placeholder="Enter Register No"
            value={registerNo}
            onChange={(e) => setRegistershipNo(e.target.value)}
            style={styles.input}
          />
          <button onClick={fetchUserData} style={styles.buttonPrimary}>Search</button>
        </div>

       {/* User Details */}
{userData && (
  <div style={styles.userCard}>

    <div style={styles.userInfo}>
      <p><FiUser style={styles.icon} /><strong>Name:</strong> {userData.name}</p>
      <p><FiMail style={styles.icon} /><strong>Email:</strong> {userData.email}</p>
      <p><FiPhone style={styles.icon} /><strong>Mobile:</strong> {userData.mobile}</p>
  
    </div>
    
    <button onClick={sendOtp} style={styles.buttonDanger}>
      <FiTrash2 style={styles.iconButton} /> Delete User
    </button>
  </div>
)}

        {/* OTP Verification */}
        {showOtpField && (
          <div style={styles.otpContainer}>
            <input
              type="text"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              style={styles.input}
            />
            <button onClick={verifyAndDeleteUser} style={styles.buttonSuccess}>Verify & Delete</button>
          </div>
        )}
      </div>

      {/* Footer */}
      <footer style={styles.footer}>
        <p>@2025 Emedha Technologies. All Rights Reserved.</p>
      </footer>
    </div>
  );
};

/* Styling */
const styles = {
  container: {
    fontFamily: 'Arial, sans-serif',
    backgroundColor: '#f4f4f4',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  header: {
    width: '100%',
    backgroundColor: '#eecbcbff', // Navy Blue
    color: '#7b3c9c', // Gold
    padding: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
  },
  logo: {
    height: '60px',
  },
  title: {
    fontSize: '22px',
    fontWeight: 'bold',
    textAlign: 'center',
    flex: 1,
  },
  content: {
    width: '100%',
    maxWidth: '600px',
    margin: '20px auto',
    padding: '20px',
    backgroundColor: '#fff',
    borderRadius: '10px',
    boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
  },
  searchContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '10px',
    marginBottom: '20px',
  },
  input: {
    padding: '10px',
    borderRadius: '5px',
    border: '1px solid #ccc',
    width: '70%',
  },
  buttonPrimary: {
    backgroundColor: '#7b3c9c',
    color: 'white',
    padding: '10px 20px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontWeight: 'bold',
  },
  buttonDanger: {
    backgroundColor: '#DC143C',
    color: 'white',
    padding: '10px 20px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    marginTop: '10px',
    fontWeight: 'bold',
  },
  buttonDanger: {
    backgroundColor: '#DC143C',
    color: 'white',
    padding: '10px 20px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    marginTop: '10px',
    fontWeight: 'bold',
  },
  buttonSuccess: {
    backgroundColor: '#DC143C',
    color: 'white',
    padding: '10px 20px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontWeight: 'bold',
  },
  userCard: {
    marginTop: '20px',
    padding: '25px',
    borderRadius: '12px',
    background: 'linear-gradient(135deg, #7b3c9c, #9464b4)', // Navy Blue Gradient
    color: '#ffffff', // Gold Text
    boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.2)',
   
  },
  cardTitle: {
    fontSize: '22px',
    fontWeight: 'bold',
    marginBottom: '15px',
    borderBottom: '2px solid #7b3c9c',
    display: 'inline-block',
    paddingBottom: '5px',
  },
  userInfo: {
    fontSize: '18px',
    lineHeight: '1.8',
    display: 'flex',
    flexDirection: 'column',

  },
  icon: {
    marginRight: '8px',
    color: '#fff', // Gold color
    fontSize: '20px',
  },
  iconButton: {
    marginRight: '5px',
    fontSize: '18px',
  },
  buttonDanger: {
    backgroundColor: '#dc3545',
    color: 'white',
    padding: '12px 25px',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '16px',
    fontWeight: 'bold',
    transition: 'background 0.3s ease, transform 0.2s',
    marginTop: '20px',
    boxShadow: '0px 4px 10px rgba(255, 0, 0, 0.3)',
  },
  buttonDangerHover: {
    backgroundColor: '#b22222',
    transform: 'scale(1.05)',
  },
  otpContainer: {
    marginTop: '20px',
    textAlign: 'center',
  },
  footer: {
    width: '100%',
    backgroundColor: '#eecbcbff',
    color: '#7b3c9c',
    padding: '15px',
    textAlign: 'center',
    fontWeight: 'bold',
  },
};

export default UserDelete;
